import FilterBoxList from './FilterBoxList';

export enum FilterBoxPriceBackgroundColor {
  WHITE = 'WHITE',
  GREY = 'GREY',
  PURPLE = 'PURPLE',
  GREEN = 'GREEN',
}

export enum FilterBoxPriceFontColor {
  BLACK = 'black',
  WHITE = 'white',
}

export interface ICarPriceFilterItem {
  _uid?: string;
  price: number;
  offersAmount: number;
  searchUrl: string;
}
export interface FilterBoxPrice {
  heading: string;
  description: string;
  filterCarPriceItems: ICarPriceFilterItem[];
  items: ICarPriceFilterItem[];
  background: FilterBoxPriceBackgroundColor;
  priceFontColor?: FilterBoxPriceFontColor;
  offersFontColor?: FilterBoxPriceFontColor;
}

export default function FilterBoxPrice({
  heading,
  description,
  filterCarPriceItems,
  items,
  background,
}: FilterBoxPrice) {
  const classNames = {
    WHITE: {
      container: 'bg-white p-10px py-60px px-40px',
      heading:
        'break-words font-headline font-weight-bold text-ellipsis text-headline3 pb-10px text-black',
      text: 'pb-20px lg:w-[50%] sm:w-[100%] text-black',
      itemContainer: 'grid sm:grid-cols-2 lg:grid-cols-6 gap-10px',
    },
    GREY: {
      container: 'bg-grey10 p-10px py-60px px-40px',
      heading:
        'break-words font-headline font-weight-bold text-ellipsis text-headline3 pb-10px text-black',
      text: 'pb-20px lg:w-[50%] sm:w-[100%] text-black',
      itemContainer: 'grid sm:grid-cols-2 lg:grid-cols-6 gap-10px',
    },
    PURPLE: {
      container: 'bg-purple80 p-10px py-60px px-40px',
      heading:
        'break-words font-headline font-weight-bold text-ellipsis text-headline3 pb-10px text-white',
      text: 'pb-20px lg:w-[50%] sm:w-[100%] text-white',
      itemContainer: 'grid sm:grid-cols-2 lg:grid-cols-6 gap-10px',
    },
    GREEN: {
      container: 'bg-green60 p-10px py-60px px-40px',
      heading:
        'break-words font-headline font-weight-bold text-ellipsis text-headline3 pb-10px text-black',
      text: 'pb-20px lg:w-[50%] sm:w-[100%] text-black',
      itemContainer: 'grid sm:grid-cols-2 lg:grid-cols-6 gap-10px',
    },
  };

  function getOffersAmount(id?: string) {
    if (!id) return 0;

    const item = filterCarPriceItems.find((value) => value._uid === id);

    return item?.offersAmount ?? 0;
  }

  return (
    <div className={classNames[background].container}>
      <div className={classNames[background].heading}>{heading}</div>
      <div className={classNames[background].text}>{description}</div>
      <div className={classNames[background].itemContainer}>
        {items.map((item, index, arr) => {
          const offersAmount = getOffersAmount(item._uid);
          return (
            <FilterBoxList
              key={item._uid}
              price={item.price}
              offersAmount={offersAmount}
              isLastItem={arr.length - 1 === index}
              searchUrl={item.searchUrl}
            />
          );
        })}
      </div>
    </div>
  );
}
